import './connect-telegram-page.scss';

import React from 'react';

import { env } from '@/shared/config/env';

const TELEGRAM_ICON = (
  <svg viewBox="0 0 24 24" className="connect-telegram-page__tg-icon" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

export const ConnectTelegramPage: React.FC = () => {
  const handleOpenTelegram = () => {
    const link = env.TELEGRAM_MINIAPP_LINK;
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  const hasLink = !!env.TELEGRAM_MINIAPP_LINK;

  return (
    <div className="connect-telegram-page">
      <div className="connect-telegram-page__bg">
        <div className="connect-telegram-page__orb connect-telegram-page__orb--top" />
        <div className="connect-telegram-page__orb connect-telegram-page__orb--bottom" />
        <div className="connect-telegram-page__grid" />
      </div>
      <div className="connect-telegram-page__content">
        <div className="connect-telegram-page__card">
          <div className="connect-telegram-page__icon-wrap">{TELEGRAM_ICON}</div>
          <h1 className="connect-telegram-page__title">PureWin Arena</h1>
          <p className="connect-telegram-page__text">
            Open this app in Telegram to play and use your account.
          </p>
          <button
            type="button"
            className="connect-telegram-page__btn"
            onClick={handleOpenTelegram}
            disabled={!hasLink}>
            {hasLink ? 'Open in Telegram' : 'Configure TELEGRAM_MINIAPP_LINK'}
          </button>
        </div>
      </div>
    </div>
  );
};
